export { default as ControlLabel } from './ControlLabel';
export * from './useControlLabel';